/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/** Request native video PiP directly within the initiating click's activation. */
export async function requestPictureInPicture(
  video: HTMLVideoElement,
  enabled: boolean,
): Promise<null> {
  if (enabled && typeof video.requestPictureInPicture === "function") {
    if (video.readyState === 0) {
      throw new DOMException("Video metadata not ready", "InvalidStateError");
    }
    await video.requestPictureInPicture();
    return null;
  }
  throw new DOMException("Picture-in-Picture unavailable", "NotSupportedError");
}
